const GENERAL_PROMPTS = Object.freeze([
  "What database connections do I have?",
  "Set up a PostgreSQL connection to localhost",
  "Where do I add an API profile?",
  "Walk me through configuring Slack OAuth",
]);

const PLC_OVERVIEW_PROMPTS = Object.freeze([
  "Walk me through setting up my first PLC runtime",
  "Which PLC runtimes need attention?",
  "Help me connect I/O to a runtime",
  "How do I deploy and run a Structured Text application?",
]);

const PLC_RUNTIME_PROMPTS = Object.freeze([
  "Help me enroll a Raspberry Pi or industrial PC",
  "Which runtimes are online right now?",
  "Help me add an I/O connection to a runtime",
  "Why is one of my runtimes offline?",
]);

const PLC_ADVANCED_PROMPTS = Object.freeze([
  "Explain the current PLC deployment status",
  "Which PLC servers are executable on this target?",
  "Show only PLC compatibility blockers that affect my selected runtime",
  "Take me back to the normal PLC setup flow",
]);

// Custom connectors: the operator describes what to scrape, in their own
// words. Each chip is a whole request the assistant can answer end to end.
const CUSTOM_COLLECTOR_PROMPTS = Object.freeze([
  "Lee el CMg online de la barra Quillota220 desde la API pública del Coordinador y entrega cmg_usd_mwh",
  "Agrégale un timeout de 10 s y un reintento al script",
  "Entrega también la hora del dato como texto",
  "Explícame qué hace este script línea por línea",
]);

export function gatewayAIPromptOptions(activeSection = "") {
  if (activeSection === "custom-collectors") return CUSTOM_COLLECTOR_PROMPTS;
  if (activeSection === "plc-runtime-fleet") return PLC_RUNTIME_PROMPTS;
  if (activeSection === "plc-overview") return PLC_OVERVIEW_PROMPTS;
  if (String(activeSection).startsWith("plc-")) return PLC_ADVANCED_PROMPTS;
  return GENERAL_PROMPTS;
}

export function gatewayAIEmptyCopy(activeSection = "") {
  if (activeSection === "custom-collectors") {
    return {
      subtitle: "Cuéntame qué debe leer el colector",
      body: "Describe la fuente y el dato que quieres (una API, un CSV, una página) y escribo el script de Python completo en el editor, con los outputs sugeridos. Nada se guarda hasta que tú pulses Guardar.",
    };
  }
  if (String(activeSection).startsWith("plc-")) {
    return {
      subtitle: "Ask about PLC setup and runtime status",
      body: "I can guide you through adding a runtime, connecting I/O, opening an application, and understanding device status. I only recommend features that are ready to use.",
    };
  }
  return {
    subtitle: "Ask about gateway configuration",
    body: "I can help you set up database connections, API profiles, MQTT brokers, OAuth apps, users, and more. I can also walk you through pages by highlighting things — I'll always open the form for you to review before anything is saved.",
  };
}

export { GENERAL_PROMPTS, PLC_ADVANCED_PROMPTS, PLC_OVERVIEW_PROMPTS, PLC_RUNTIME_PROMPTS };
